import { AtOutline, SmileyOutline } from '@lyearn/icons';
import { Emoji, getEmojiPlugin, getMentionsPlugin, Mention } from '@lyearn/lygo-blocks';
import { EditorOptionMap } from '@/components/Editor/PlainEditor/const';
import { EditorOptionType, ToolbarOption } from '@/components/Editor/PlainEditor/types';
import UserTooltipProvider from '@/components/User/layouts/UserTooltipProvider';
import EmojiList from '@/modules/corporate/modules/channel/views/ChannelDetails/components/MessageInput/plugins/Emoji';
import MentionsList from '@/modules/corporate/modules/channel/views/ChannelDetails/components/MessageInput/plugins/Mentions';
import * as Mentions from '@/modules/corporate/modules/channel/views/ChannelDetails/components/MessageInput/plugins/Mentions/mention-entities';
import { MentionEntityTypeEnum } from '@/types/schema';

import AddEmojiOption from '../AddEmojiOption';
import AddMentionOption from '../AddMentionOption';

export const PRAISE_MESSAGE_TOOLBAR_ADD_EMOJI_KEY = 'AddEmoji';
export const PRAISE_MESSAGE_TOOLBAR_ADD_MENTION_KEY = 'AddMention';

export const PRAISE_MESSAGE_EDITOR_DEFAULT_OPTIONS = [
  ToolbarOption.AttachFile,
  PRAISE_MESSAGE_TOOLBAR_ADD_EMOJI_KEY,
  PRAISE_MESSAGE_TOOLBAR_ADD_MENTION_KEY,
];

export const PRAISE_MESSAGE_EXTENSIONS = [Emoji, Mention];

export const PRAISE_MESSAGE_EDITOR_OPTION_MAP = new Map<string, EditorOptionType>([
  [
    ToolbarOption.AttachFile,
    { ...EditorOptionMap.get(ToolbarOption.AttachFile)!, accept: 'image/*,video/*' }!,
  ],
  [
    PRAISE_MESSAGE_TOOLBAR_ADD_EMOJI_KEY,
    {
      Component: AddEmojiOption,
      key: PRAISE_MESSAGE_TOOLBAR_ADD_EMOJI_KEY,
      className: 'me-2',
      Icon: SmileyOutline,
      blockName: '',
    },
  ],
  [
    PRAISE_MESSAGE_TOOLBAR_ADD_MENTION_KEY,
    {
      Component: AddMentionOption,
      key: PRAISE_MESSAGE_TOOLBAR_ADD_MENTION_KEY,
      className: 'me-2',
      Icon: AtOutline,
      blockName: '',
    },
  ],
]);

const PRAISE_MESSAGE_MENTIONS_FACTORY = {
  USER: Mentions.UserMention,
};

export const PRAISE_MESSAGE_PLUGINS = [
  getEmojiPlugin({ ListComponent: EmojiList }),
  getMentionsPlugin({
    ListComponent: (props) => (
      <MentionsList
        MentionsFactory={PRAISE_MESSAGE_MENTIONS_FACTORY}
        defaultView={MentionEntityTypeEnum.User}
        {...props}
      />
    ),
    UserTooltipProvider: UserTooltipProvider,
  }),
];
